module.exports = __webpack_public_path__ + "media/images/stock_groups/e566-e3df9bf019fdc5e9801f949c69cca3dd.svg";